import { useAppUser, useConfig } from '@bechtel/client-common';
export function useShowMap() {
  const { user } = useAppUser();
  const { features } = useConfig();
  const projectLocationObj = user?.project?.projectConfiguration?.projectLocation;
  return {
    showMap:
      !!projectLocationObj?.maxLatitude &&
      !!projectLocationObj?.maxLongitude &&
      !!projectLocationObj?.minLatitude &&
      !!projectLocationObj?.minLongitude &&
      features?.showMapView,
  };
}
